module.exports = __webpack_public_path__ + "static/media/Lima_256x256px.32a181f9.jpg";